import React from "react";
import * as api from "../../firebase/firebaseApi";

const AdminTest = ()=>{
    const handleApi = ()=>{
       api.getShippingInvoice()
    }
    console.clear()
    return (
        <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",backgroundColor:"black",height:"100vh"}}>
            <div>
                <button className="btn btn-primary btn-lg "
                onClick={handleApi}
                >Test Api</button>
            </div>
        </div>
    )
}
export default AdminTest  